var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormButton',{attrs:{"variant":_vm.variant},on:{"click":_vm.toggleState}},[(!_vm.loading)?_c('Icon',{staticClass:"mr-2 h-3 w-3 text-inherit",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }